import { AppHTTPService } from '@/api/http-service'
import { connectionManager } from '@/api/sse/prepare-chat'
import { useThreadRegistry } from '@/api/sse/prepare-chat/thread-provider'
import { useState, useRef, useCallback, useEffect } from 'react'
import { PrepareChatConfig, AgentStatus } from './types'

/**
 * Hook for managing thread connection and lifecycle
 */
function useThreadController(config?: PrepareChatConfig) {
  const [threadId, setThreadId] = useState<string | null>(
    config?.threadId || null
  )
  const [status, setStatus] = useState<AgentStatus>('initializing')
  const [isLoading, setIsLoading] = useState(false)
  const abortControllerRef = useRef<AbortController | null>(null)
  const { isRegistered } = useThreadRegistry(threadId)

  /**
   * Creates a new thread or returns existing thread ID
   */
  const createOrGetThread = useCallback(async (): Promise<string> => {
    console.log('createOrGetThread', { threadId })
    if (threadId) {
      return threadId
    }

    try {
      const newThreadId = '123'
      console.log('thread not found, fetch the latest chat thread', {
        newThreadId,
      })
      // const response = await AppHTTPService.axios.post('/threads', {
      //   resourceId: config?.sourceSheetId,
      //   source: config?.sourceSheetId,
      //   metadata: {
      //     description: 'createOrGetThread() Thread',
      //   },
      //   type: 'chat',
      // })
      // const thread = response.data.data
      // const newThreadId = thread.id
      // setThreadId(newThreadId)
      return newThreadId
    } catch (error) {
      console.error('Error creating thread:', error)
      throw new Error('Failed to create thread')
    }
  }, [threadId, config?.sourceSheetId])

  // /**
  //  * Updates thread state in the database
  //  */
  // const updateThreadState = useCallback(
  //   async (threadId: string, stateUpdate: Record<string, any>) => {
  //     try {
  //       // TODO: OLD Thread Update API
  //       const response = await AppHTTPService.client.threads.update(
  //         threadId,
  //         stateUpdate
  //       )
  //       return response.data
  //     } catch (error) {
  //       console.error('Error updating thread state:', error)
  //       throw error
  //     }
  //   },
  //   [config?.threadId]
  // )

  /**
   * Stops any in-progress thread operations
   */
  const handleStop = useCallback(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort()
      abortControllerRef.current = null
    }
    setIsLoading(false)
  }, [])

  // Initialize thread on component mount if initMessage is provided
  // useEffect(() => {
  //   if (config?.initMessage && config?.sourceSheetId && !isRegistered) {
  //     setStatus('initializing')
  //   } else {
  //     setStatus('online')
  //   }

  //   return () => {
  //     // if (threadId) {
  //     //   connectionManager.closeResource(threadId)
  //     // }
  //   }
  // }, [config?.initMessage, config?.sourceSheetId, threadId, isRegistered])

  return {
    threadId,
    setThreadId,
    status,
    setStatus,
    isLoading,
    setIsLoading,
    createOrGetThread,
    // updateThreadState,
    handleStop,
  }
}

export { useThreadController }
